export const NOTE = `Notes`;
export const SAVE = `Save`;
export const CANCEL = `Cancel`;
export const OK = 'Ok';
export const CONFIRMATION = `Confirmation`;
export const NO = `No`;
export const YES = `Yes`;
export const ALERT = `Alert`;
export const RESOURCE_MANAGEMENT_TITLE  = `Resource Management Dashboard`;